import { createAction, union } from '@ngrx/store';
import {
  zefActionPayload,
  zefActionFailPayload,
  zefActionSuccessPayload
} from '@zerops/zef/core';

export const sync = createAction(
  '[@zerops/zerops/core/user-data-base] sync',
  zefActionPayload<string, { global: boolean }>()
);

export const syncFail = createAction(
  '[@zerops/zerops/core/user-data-base] sync/fail',
  zefActionFailPayload
);

export const syncSuccess = createAction(
  '[@zerops/zerops/core/user-data-base] sync/success',
  // TODO: interface
  zefActionSuccessPayload()
);

export const updateSecretEnvs = createAction(
  '[@zerops/zerops/core/user-data-base] update-secret-envs',
  zefActionPayload<{ id: string; content: string; sensitive?: boolean; }>()
);

export const updateSecretEnvsFail = createAction(
  '[@zerops/zerops/core/user-data-base] update-secret-envs/fail',
  zefActionFailPayload
);

export const updateSecretEnvsSuccess = createAction(
  '[@zerops/zerops/core/user-data-base] update-secret-envs/success',
  zefActionSuccessPayload()
);

// `openEditorOnSuccess` marks a bulk-reveal whose sole purpose is to populate and
// open the multi-edit dialog. Like `copyOnSuccess` on `revealUserData` below, it
// rides on the action so it survives the sudo re-auth replay - the editor is shown
// only once the decrypted file is actually in hand, never before re-auth is approved.
export const loadUserDataEnvFile = createAction(
  '[@zerops/zerops/core/user-data-base] load-user-data-env-file',
  zefActionPayload<{ id: string; sensitive?: boolean; openEditorOnSuccess?: boolean; }>()
);

export const loadUserDataEnvFileFail = createAction(
  '[@zerops/zerops/core/user-data-base] load-user-data-env-file/fail',
  zefActionFailPayload
);

export const loadUserDataEnvFileSuccess = createAction(
  '[@zerops/zerops/core/user-data-base] load-user-data-env-file/success',
  zefActionSuccessPayload<{ envFile: string; }>()
);

// `copyOnSuccess` marks a reveal that was triggered by a copy intent (the user
// clicked the masked value itself, not the eye toggle). It rides on the action so it
// survives the sudo re-auth replay, and is honoured centrally by the effect below.
export const revealUserData = createAction(
  '[@zerops/zerops/core/user-data-base] reveal-user-data',
  zefActionPayload<{ id: string; copyOnSuccess?: boolean; }>()
);

export const revealUserDataFail = createAction(
  '[@zerops/zerops/core/user-data-base] reveal-user-data/fail',
  zefActionFailPayload
);

export const revealUserDataSuccess = createAction(
  '[@zerops/zerops/core/user-data-base] reveal-user-data/success',
  zefActionSuccessPayload<{ content: string; }>()
);

export const hideUserData = createAction(
  '[@zerops/zerops/core/user-data-base] hide-user-data',
  (id: string) => ({ id })
);

export const clearRevealedUserData = createAction(
  '[@zerops/zerops/core/user-data-base] clear-revealed-user-data'
);

export const setActiveId = createAction(
  '[@zerops/zerops/core/user-data-base] set-active-id',
  (id: string) => ({ id })
);

const all = union({
  sync,
  syncFail,
  syncSuccess,
  setActiveId,
  updateSecretEnvs,
  updateSecretEnvsFail,
  updateSecretEnvsSuccess,
  loadUserDataEnvFile,
  loadUserDataEnvFileFail,
  loadUserDataEnvFileSuccess,
  revealUserData,
  revealUserDataFail,
  revealUserDataSuccess,
  hideUserData,
  clearRevealedUserData
});

export type UserDataBaseActionUnion = typeof all;
